import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({ name: 'solution' })
export class SolutionPipe implements PipeTransform {
  transform(value: string[], separator = ', '): string {
    const formattedSolutions = [];
    value.forEach((solution) => {
      switch (solution) {
        case 'insight':
          formattedSolutions.push(_.replace(solution, 'insight', 'InSight'));
          break;
        case 'inspect':
          formattedSolutions.push(_.replace(solution, 'inspect', 'InSpect'));
          break;
        case 'cleansweep':
          formattedSolutions.push(_.replace(solution, 'cleansweep', 'InSpect'));
          break;
        case 'uv_solution':
          formattedSolutions.push(
            _.replace(solution, 'uv_solution', 'UV Disinfect')
          );
          break;
        case 'focus':
          formattedSolutions.push(_.replace(solution, 'focus', 'Focus'));
          break;
        case 'rfid':
          formattedSolutions.push(_.replace(solution, 'rfid', 'RFID'));
          break;
        case 'top_stock':
          formattedSolutions.push(
            _.replace(solution, 'top_stock', 'Top Stock')
          );
          break;
        case 'product_identification':
          formattedSolutions.push(
            _.replace(
              solution,
              'product_identification',
              'Product Identification'
            )
          );
          break;
        case 'security_checkpoint_walk':
          formattedSolutions.push(
            _.replace(
              solution,
              'security_checkpoint_walk',
              'Security Checkpoint Walk'
            )
          );
          break;
        case 'security_patrol':
          formattedSolutions.push(
            _.replace(solution, 'security_patrol', 'Security Patrol')
          );
          break;
        case 'delivery':
          formattedSolutions.push(_.replace(solution, 'delivery', 'Delivery'));
          break;
        default:
          formattedSolutions.push(solution);
          break;
      }
    });
    return formattedSolutions.join(separator);
  }
}
